'use client';

import { formatPrice } from '@/lib/utils/formatPrice';
import { isTaxIncluded } from '@/lib/tax';
import type { TaxedMoney } from '@/lib/checkout/types';

interface TaxedPriceProps {
  price: TaxedMoney;
  countryCode: string;
  locale?: string;
  className?: string;
}

export const TaxedPrice = ({ price, countryCode, locale, className }: TaxedPriceProps) => {
  const displayAmount = isTaxIncluded(countryCode) ? price.gross : price.net;
  const formatted = formatPrice(displayAmount.amount, displayAmount.currency, locale);

  return <span className={className}>{formatted}</span>;
};
